module.exports = __webpack_public_path__ + "views/profile.8f3cd37f9c3aebdffe6744c45c18dfbd.html";